import script from "./DigitCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./DigitCode.vue?vue&type=script&lang=ts&setup=true"

import "./DigitCode.vue?vue&type=style&index=0&id=4986ed72&lang=css"

const __exports__ = script;

export default __exports__